<template>
    <div class="container">
      <iframe src="https://vk.com/video_ext.php?oid=-117164278&id=456239100&hd=3&autoplay=1"  class="firetest" width="1280" height="720" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe></div>
</template>
<script>
export default {
  name: 'firetest'
}
</script>
<style>
.firetest {
  margin: auto;
    width: 100%;
    height: 100%;
    min-height: 855px;
}
@media (min-width: 320px)  and (max-width: 374px){
.firetest {
    width: 100%;
    min-height: 100px;
}
}
@media (min-width: 375px)  and (max-width: 767px) {
.firetest {
    width: 100%;
    min-height: 200px
}
}
@media (min-width: 768px)  and (max-width: 1023px){
.firetest {
    width: 100%;
    min-height: 300px;
}
}
@media (min-width: 1440px) and (max-width: 1919px){
        .firetest {
    width: 100%;
    min-height: 400px;
}
}
@media (min-width: 1280px) and (max-width: 1439px){
    .firetest {
    width: 100%;
    min-height: 200px;
}
}
@media (min-width: 1024px) and (max-width: 1279px){
    .firetest {
    margin: 0 auto;
    width: 100%;
    min-height: 400px;
}
}

</style>
